<template>
    <div>
        <div id="map">
            <GmapMap
                :center="position"
                :zoom="7"
                :options="{
                    zoomControl: false,
                      mapTypeControl: false,
                      scaleControl: false,
                      streetViewControl: false,
                      rotateControl: false,
                      fullscreenControl: false,
                      disableDefaultUi: false
                }"
                map-type-id="roadmap"
            >
                <GmapMarker :position="position" />
            </GmapMap>
        </div>
        <section>
            <div class="c contact__details layout__main-side flex -wrap -space-between">
                <div class="contact__form ms-main">
                    <h2>{{ $t('contact.contact') }}</h2>
                    <Form :send-text="$t('contact.send')" :send-error="$t('contact.send_error')" :inputs="formdata" formname="contact">
                        <label for="naam">{{ $t('contact.name') }}</label>
                        <input type="text" name="naam" id="naam" class="input" autocomplete="name" v-model="formdata.naam" required />
                        <label for="bedrijfsnaam">{{ $t('contact.company_name') }}</label>
                        <input type="text" name="bedrijfsnaam" id="bedrijfsnaam" class="input" autocomplete="organization" v-model="formdata.bedrijfsnaam" required />
                        <label for="kvk">{{ $t('contact.coc_number') }}</label>
                        <input type="text" name="kvk" id="kvk" class="input" v-model="formdata.kvk" required />
                        <label for="emailadres">{{ $t('contact.email') }}</label>
                        <input type="email" name="emailadres" id="emailadres" class="input" autocomplete="email" v-model="formdata.emailadres" required />
                        <label for="bericht">{{ $t('contact.message') }}</label>
                        <textarea class="input" id="bericht" name="bericht" v-model="formdata.bericht" required></textarea><br />
                    </Form>
                </div>
                <div class="contact__side ms-side">
                    <h2>{{ $t('contact.info') }}</h2>
                    <div v-html="$options.filters.linkify(webdata('contact.contactinfo', true))"></div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import Form from '@/components/Form.vue';

export default {
    name: 'Contact',
    components: { Form },
    data() {
        return {
            formdata: {
                naam: '',
                emailadres: '',
                bedrijfsnaam: '',
                kvk: '',
                bericht: '',
            },
        };
    },
    computed: {
        position() {
            return { lat: this.webdata('contact.adres_voor_kaart.lat'), lng: this.webdata('contact.adres_voor_kaart.lng') };
        },
    },
};
</script>
<style>
    #map { overflow: hidden; }
    .vue-map-container {
        height: 50vh; max-height: 50rem;
        margin-top: 9rem;
        width: 100%;
    }
</style>
